export default __webpack_public_path__ + "static/media/p01 p03.b8b33f93.jpg";